'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var daoReducer = function daoReducer() {
	var state = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	var action = arguments[1];

	switch (action.type) {
		case 'LOGIN_SUCCESS':
			return _extends({}, state, {
				authToken: action.authToken,
				refreshToken: action.refreshToken
			});
		case 'REGISTERED':
			return _extends({}, state, {
				authToken: action.authToken,
				refreshToken: action.refreshToken
			});
		case 'LOGOUT_SUCCESS':
		case 'LOGOUT_FAILURE':
			return _extends({}, state, {
				authToken: undefined,
				refreshToken: undefined
			});
		case 'UNAUTHORISED':
			return _extends({}, state, {
				authToken: undefined,
				refreshToken: undefined
			});
		case 'REFRESH_AUTH_TOKEN':
			return _extends({}, state, {
				isRefreshingAuthToken: true
			});
		case 'REFRESH_AUTH_TOKEN_SUCCESS':
			return _extends({}, state, {
				authToken: action.authToken,
				refreshToken: action.refreshToken,
				isRefreshingAuthToken: false
			});
		case 'UPDATE_PASSWORD_SUCCESS':
			return _extends({}, state, {
				authToken: action.authToken,
				refreshToken: action.refreshToken
			});
		default:
			return state;
	}
};

exports.default = daoReducer;


/*****************
 ** WEBPACK FOOTER
 ** ./~/ml-fetch/dist/reducer/daoReducer.js
 ** module id = 646
 ** module chunks = 0
 **/